'use client';

import { cn } from '@coas/ui/lib';
import { useState } from 'react';
import { EmailForm } from './EmailForm';
import { PhoneForm } from './PhoneForm';

export default () => {
    const [provider, setProvider] = useState<'phone' | 'email'>('phone');

    return (
        <div className='mx-auto w-full max-w-md'>
            <div className='mb-4 flex items-stretch'>
                <button
                    type='button'
                    className={cn(
                        'flex-1 border-b-2 py-2 text-center',
                        provider === 'phone' ? 'border-blue-600 font-bold' : 'border-neutral-300 text-neutral-500',
                    )}
                    onClick={() => setProvider('phone')}
                >
                    Телефон
                </button>
                <div className={'w-px border-b-2 border-b-neutral-300 py-3'}>
                    <div className={'h-full w-full bg-neutral-300'} />
                </div>
                <button
                    type='button'
                    className={cn(
                        'flex-1 border-b-2 py-2 text-center',
                        provider === 'email' ? 'border-blue-600 font-bold' : 'border-neutral-300 text-neutral-500',
                    )}
                    onClick={() => setProvider('email')}
                >
                    Почта
                </button>
            </div>

            {provider === 'phone' && <PhoneForm />}
            {provider === 'email' && <EmailForm />}
        </div>
    );
};
